import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, Phone } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { Logo } from "@/components/site/Logo";
import { CONTACT } from "@/lib/api";

const LINKS = [
  { to: "/", label: "Accueil", id: "home" },
  { to: "/programmes", label: "Nos programmes", id: "programmes" },
  { to: "/#services", label: "Services", id: "services" },
  { to: "/contact", label: "Contact", id: "contact" },
];

const linkCls = ({ isActive }) =>
  `text-sm tracking-wide transition-colors duration-300 ${isActive ? "text-[#D4A373]" : "text-white/75 hover:text-white"}`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 bg-[#1A1716]/85 backdrop-blur-xl border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 h-20 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-10">
          {LINKS.map((l) => (
            <NavLink key={l.id} to={l.to} end className={l.id === "services" ? linkCls({ isActive: false }) : linkCls} data-testid={`nav-${l.id}-link`}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-4">
          <a href={`tel:${CONTACT.tel}`} className="flex items-center gap-2 text-white/80 hover:text-white text-sm transition-colors" data-testid="header-phone-link">
            <Phone className="h-4 w-4 text-[#C88A58]" /> {CONTACT.phone}
          </a>
          <Link to="/contact" className="px-5 py-2.5 bg-[#C88A58] hover:bg-[#b57849] text-white text-sm rounded-full transition-colors duration-300" data-testid="header-cta-button">
            Prendre rendez-vous
          </Link>
        </div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger className="lg:hidden text-white p-2" data-testid="mobile-menu-button">
            <Menu className="h-6 w-6" />
          </SheetTrigger>
          <SheetContent side="right" className="bg-[#1A1716] border-white/10 text-white">
            <SheetTitle className="text-white/50 eyebrow">Menu</SheetTitle>
            <div className="flex flex-col gap-6 mt-10">
              {LINKS.map((l) => (
                <NavLink key={l.id} to={l.to} end onClick={() => setOpen(false)} className="font-display text-3xl text-white" data-testid={`mobile-nav-${l.id}-link`}>
                  {l.label}
                </NavLink>
              ))}
              <a href={`tel:${CONTACT.tel}`} className="mt-6 flex items-center gap-2 text-[#D4A373]">
                <Phone className="h-4 w-4" /> {CONTACT.phone}
              </a>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
